
<div class="modal-wrapper-container">
  <div class="modal-content">
    <div *ngComponentOutlet="data.component; injector: toInject"></div>
  </div>
  <div class="modal-header">
    <h1 class="title">{{data.title}}</h1>
    <button 
      mat-icon-button 
      class="close-btn" 
      id="modal-wrapper-close-btn" 
      type="button" 
      *ngIf="!disableCloseBtn"
      (click)="dialogRef.close(false)"
      [autofocus]="false"
      aria-label="Fechar Modal">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
</div>